var path = '/pages/vouchers/templates/views/base.tpl.html';
var html = "<div class=\"height-less-navbar\" ng-show=\"$state.current.data.view == 'list'\" ui-view=\"list\"></div>\n<div class=\"height-less-navbar\" ng-show=\"$state.current.data.view == 'details'\" ui-view=\"details\"></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vouchers/templates/views/base.tpl.html
// module id = 2331
// module chunks = 1